import { render, staticRenderFns } from "./employee-widget.vue?vue&type=template&id=c0bc07ce&scoped=true&"
import script from "./employee-widget.vue?vue&type=script&lang=js&"
export * from "./employee-widget.vue?vue&type=script&lang=js&"
import style0 from "./employee-widget.vue?vue&type=style&index=0&id=c0bc07ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0bc07ce",
  null
  
)

export default component.exports